export const en = {
    title: 'Go on your first business trip with Yandex',
    add_email_caption: 'Please write your work email address, which is linked to the company domain',
};
